module.exports = __webpack_public_path__ + "img/icon-download.3e705aab.svg";